import ReactModal from "react-modal";
import theme from "../styles/theme";

type Props = {
  isOpen: boolean;
  setOpen: any;
  onDismiss?: () => void;
  onClose?: (courseId: any, section: any) => void;
  children?: any;
  customStyle?: any;
  overlayClassName?: any;
};

function Modal({
  isOpen,
  setOpen,
  onDismiss,
  onClose,
  children = null,
  customStyle,
}: Props): JSX.Element {
  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false} // This prevents closing on overlay click
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={() => {
          setOpen(false);
          onClose?.("", "");
        }}
        closeTimeoutMS={500}
        style={{
          overlay: {
            zIndex: 9900,
            paddingLeft: theme.spacing.x3,
            paddingRight: theme.spacing.x3,
            background: "rgb(0 0 0 / 43%)",
            overflow: "auto",
            ...customStyle?.overlay,
          },
          content: {
            border: "unset",
            maxWidth: 400,
            // background: 'rgba(35,37,48,255)',
            color: "#000000",
            margin: `calc(${theme.navbarHeight} + ${theme.spacing.x3}) auto ${theme.spacing.x4}`,
            position: "static",
            padding: theme.spacing.x2,
            overflow: "visible",
            borderRadius: "8px",
            ...customStyle?.content,
          },
        }}
      >
        {children}
      </ReactModal>
    </>
  );
}

export default Modal;
